import { PrivacyPreferenceData } from '../schema/api3/types/Api3PrivacyPreferences';
import { Api3Profile } from '../schema/api3/types/Api3Profile';
import { AsyncResult } from '../types/AsyncResult';
import { ProfileData } from './ProfileData';

export enum IdentityProvider {
  HEALTHENGINE = 'Healthengine',
  CORPORATE_GROUP = 'Corporate Group',
}

export type UserData = ProfileData & {
  userId?: string;
  clientUserId?: string;
  primaryProfileId?: string;
  profiles: Array<ProfileData>;
  privacyPreferences?: PrivacyPreferenceData;
  updateProfile?: (profile: Api3Profile) => Promise<void>;
  updatePrivacyPreferences?: (privacyPreferences: PrivacyPreferenceData) => Promise<void>;
};

export type UserResult = AsyncResult<UserData> & { identityProvider?: IdentityProvider };
